import React from 'react';
import PropTypes from 'prop-types';
import { StyledListFormat, StyledItem } from './style';
import { FormatTxt } from '../FormatTxt';

const ListFormat = ({ formats, active, className }) => (
  <React.Fragment>
    {formats && active && (
      <StyledListFormat className={className}>
        {formats.map((formatItem, index) => (
          <StyledItem key={formatItem.name[index]}>
            <FormatTxt
              format={formatItem.name}
              href={formatItem.href}
              light={active}
            />
          </StyledItem>
        ))}
      </StyledListFormat>
    )}
  </React.Fragment>
);
ListFormat.propTypes = {
  className: PropTypes.string,

  /** Formatos disponibles (Ej. pdf, doc, etc) */
  formats: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      href: PropTypes.string
    })
  ).isRequired,

  /** Le dice a FormatTxt como pintarse */
  active: PropTypes.bool
};

ListFormat.defaultProps = {
  className: undefined,
  active: false
};

export default ListFormat;
